export default "../img/logo_1.svg";